import { Routes, Route } from 'react-router-dom';
import Course from './list';
import AddCourse from './add';
import EditCourse from './edit';
import ViewCourse from './view';


const CourseRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Course />} />
      <Route path="/add" element={<AddCourse />} />
      <Route path="/edit/:id" element={<EditCourse />} />
      <Route path="/view/:id" element={<ViewCourse />} />
    </Routes>
  );
};

export default CourseRoutes;
